module.exports = __webpack_public_path__ + "static/img/star.1532a5be.png";